import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LeftArrow, RightArrow } from "src/components";
import { _ } from "src/services";
import { ProfileData, ProfileDataAction } from "src/store";

export const ProfileDevices: React.FC = () => {

    //#region Dependencies

    const dispatch = useDispatch();
    const user: ProfileData = useSelector((state: any) => state.ProfileDataState);

    //#endregion

    //#region properties

    const devices = user.devices;

    //#endregion

    //#region mehtods

    const toggleAccess = (currentDevice?: boolean) => dispatch(ProfileDataAction.sendDeviceCode(currentDevice));

    const fetchData = (page: number = 1) => dispatch(ProfileDataAction.getDevices(page));

    //#endregion

    //#region effects

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //#endregion

    const renderPagination = () => {

        if (devices.pages <= 1) return;

        const pageNos = 5;
        let minPage = 1;
        if (devices.page > pageNos / 2) minPage = Math.ceil(devices.page - (pageNos / 2));

        let maxPage = minPage + pageNos - 1;
        if (maxPage > devices.pages) {
            minPage -= maxPage - devices.pages;
            maxPage = minPage + pageNos - 1;
        }

        minPage = minPage > 0 ? minPage : 1;
        maxPage = maxPage <= devices.pages ? maxPage : devices.pages;

        const result = [
            <li key={-1} className={devices.page === 1 ? "disabled" : ""}>
                <span onClick={() => devices.page === 1 ? null : fetchData(1)} >
                    <RightArrow />
                </span>
            </li>
        ];

        for (let index = minPage; index <= maxPage; index++) {
            result.push(<li key={index} className={index === devices.page ? "current-page" : ""}>
                <span onClick={() => index === devices.page ? null : fetchData(index)} > {index}</span>
            </li>);
        }

        result.push(<li key={-2} className={devices.page === devices.pages ? "disabled" : ""}>
            <span onClick={() => devices.page === devices.pages ? null : fetchData(devices.pages)} >
                <LeftArrow />
            </span>
        </li>);

        return (<ul className="pagination">{result}</ul>);
    };

    return (
        <>
            <div className="d-flex justify-content-center w-100 mb-4">
                <span
                    onClick={() => devices.loading ? undefined : toggleAccess(false)}
                    className={`btn-revoke ${devices.loading ? " disabled" : ""}`}>
                    {_("terminateAllAccesses")}
                </span>
            </div>
            <div className="profile-table d-none d-md-block">
                <table>
                    <thead>
                        <tr>
                            <td>{_("deviceType")}</td>
                            <td style={{ maxWidth: 160, width: 160 }}>{_("deviceRegisterDate")}</td>
                            <td style={{ maxWidth: 150, width: 150 }}>{_("status")}</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            !devices.loading && devices.list.sort((x, y) => x.current ? -1 : y.current ? 1 : 0).map((x, index) => (
                                <tr key={index} className={x.current ? "highlight" : ""}>
                                    <td>{x.platform}</td>
                                    <td className="ltr">{x.registerDate}</td>
                                    <td>
                                        {!x.current && <span className="d-block disabled text-center w-100">{_(x.hasAccess ? "deviceHasAccess" : "deviceHasNotAccess")}</span>}
                                        {x.current && x.hasAccess &&
                                            <span className="d-block disabled text-center w-100">{_("currentDevice")}</span>
                                        }
                                        {
                                            x.current && !x.hasAccess &&
                                            <span className="clickable clickable-btn" onClick={() => toggleAccess(true)}>
                                                {_("restoreAccess")}
                                            </span>
                                        }
                                    </td>
                                </tr>
                            ))
                        }
                        {
                            devices.loading &&
                            [...new Array(10)].map((x, index) => (
                                <tr key={index}>
                                    <td><span className="shimmer"></span></td>
                                    <td><span className="shimmer"></span></td>
                                    <td><span className="shimmer"></span></td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
            <div className="profile-devices d-block d-md-none">
                {
                    !devices.loading && devices.list.sort((x, y) => x.current ? -1 : y.current ? 1 : 0).map((x, index) => (
                        <div key={index} className="profile-device">
                            {x.current && <span className="current-device">{_("currentDevice")}</span>}
                            <div className="info d-flex justify-content-between">
                                <span>{_("deviceType")}</span>
                                <span>{x.platform}</span>
                            </div>
                            <div className="info d-flex justify-content-between">
                                <span>{_("deviceRegisterDate")}</span>
                                <span className="ltr">{x.registerDate}</span>
                            </div>
                            {!x.current &&
                                <div className="info d-flex justify-content-between">
                                    <span>{_("status")}</span>
                                    <span>{_(x.hasAccess ? "deviceHasAccess" : "deviceHasNotAccess")}</span>
                                </div>
                            }
                             {x.current && x.hasAccess &&
                                <div className="info d-flex justify-content-between">
                                    <span>{_("status")}</span>
                                    <span>{_("currentDevice")}</span>
                                </div>
                            }
                            {x.current && !x.hasAccess &&
                                <span className="action-btn" onClick={() => toggleAccess(true)}>
                                    {_("restoreAccess")}
                                </span>
                            }
                        </div>
                    ))
                }
                {
                    devices.loading &&
                    [...new Array(10)].map((x, index) => (
                        <div key={index} className="profile-device">
                            {index === 0 && <span className="current-device">{_("currentDevice")}</span>}
                            <div className="info d-flex justify-content-between">
                                <span className="shimmer" />
                                <span className="shimmer" />
                            </div>
                            <div className="info d-flex justify-content-between">
                                <span className="shimmer" />
                                <span className="shimmer" />
                            </div>
                            <div className="info d-flex justify-content-between">
                                <span className="shimmer" />
                                <span className="shimmer" />
                            </div>
                        </div>
                    ))
                }
            </div>
            { renderPagination()}
        </>
    );

};